/* Explicit preorder and verified manufacturer purchase UI policy. */
(() => {
  function purchaseState(record, explicitPreorder, now = Date.now()) {
    if (!record) return 'contact';
    if (record.state === 'contact') return 'contact';
    if (record.available && record.quantity > 0) return 'local';
    if (record.available && explicitPreorder) return 'preorder';
    if (record.available && record.state === 'supplier' && record.sheetApproved) return 'supplier';
    const checked = Date.parse(record.checked), expires = Date.parse(record.expires);
    if (record.available && record.state === 'supplier' && Number.isFinite(checked) && Number.isFinite(expires) && checked <= now && now - checked < 86400000 && expires > now) return 'supplier';
    return 'contact';
  }
  if (typeof module !== 'undefined') module.exports = { purchaseState };
  if (typeof window === 'undefined' || customElements.get('wi-purchase-rules')) return;
  document.addEventListener('click', event => {
    const action = event.target.closest('.bls__js-addtocart');
    const card = action?.closest('[data-wi-card-state]');
    if (!card || card.dataset.wiCardState !== 'supplier' || card.dataset.wiCardApproved === 'true') return;
    const now = Date.now(), checked = Date.parse(card.dataset.wiCardChecked), expires = Date.parse(card.dataset.wiCardExpires);
    if (!Number.isFinite(checked) || !Number.isFinite(expires) || checked > now || now - checked >= 86400000 || expires <= now) {
      event.preventDefault(); event.stopImmediatePropagation(); location.assign(card.dataset.wiCardUrl);
    }
  }, true);
  customElements.define('wi-purchase-rules', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.root) return;
        this.root = this.closest('.bls__product-details-infor,.bls__product-quickview');
        if (!this.root) return;
        try { this.records = new Map(JSON.parse(this.querySelector('script').textContent).map(r => [String(r.id), r])); }
        catch { this.records = new Map(); }
        this.scope = this.root.closest('.shopify-section') || this.root;
        this.fallback = this.querySelector('[data-wi-contact-fallback]');
        this.change = () => this.queue();
        this.guard = event => {
          if (this.state !== 'contact' || event.target.closest('[data-wi-contact-fallback]')) return;
          if (event.type === 'submit' && event.target.matches('form[data-type="add-to-cart-form"]') || event.type === 'click' && event.target.closest('button[type="submit"][name="add"],.shopify-payment-button')) {
            event.preventDefault(); event.stopImmediatePropagation();
            this.fallback.querySelector('button')?.click();
          }
        };
        this.root.addEventListener('change', this.change);
        this.scope.addEventListener('submit', this.guard, true);
        this.scope.addEventListener('click', this.guard, true);
        this.observer = new MutationObserver(() => this.queue());
        this.observer.observe(this.root, {childList:true, subtree:true, attributes:true, attributeFilter:['value','disabled']});
        this.timer = setInterval(() => { this.apply(); this.refresh(); }, 30000);
        this.scope.addEventListener('change', this.change);
        this.apply();
      });
    }
    queue() { if (!this.pending) { this.pending = true; queueMicrotask(() => { this.pending = false; this.apply(); }); } }
    apply() {
      if (!this.root) return;
      const es = (document.documentElement.lang || '').toLowerCase().startsWith('es');
      const input = this.root.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
      const id = input?.value || this.dataset.selected;
      const record = this.records.get(String(id));
      this.state = purchaseState(record, this.dataset.preorder === 'true');
      const shipping = this.querySelector('[data-wi-shipping]');
      const supplierOrder = this.dataset.supplierOrder === 'true' && record?.available && record.price > 0 && record.quantity <= 0 && record.policy === 'continue' && (!record.sourceStatus || record.sourceStatus === 'available');
      const shippingState = supplierOrder ? 'supplier' : this.state;
      const message = shippingState === 'local' ? (es ? 'Normalmente se envía en 2–3 días.' : 'Usually ships in 2–3 days.') : shippingState === 'supplier' ? (es ? 'Normalmente se envía en 7–10 días hábiles.' : 'Usually ships within 7–10 business days.') : '';
      if (shipping.textContent !== message) shipping.textContent = message;
      shipping.hidden = !message;
      const template = this.fallback.querySelector('template');
      const fields = template?.content;
      const model = fields?.querySelector('[name="contact[Model]"]');
      if (model) model.value = record?.sku || '';
      const productUrl = fields?.querySelector('[name="contact[Product URL]"]');
      if (productUrl) productUrl.value = location.origin + this.dataset.url + '?variant=' + id;
      const contact = this.state === 'contact';
      this.fallback.hidden = !contact;
      this.root.dataset.wiPurchaseContact = String(contact);
      if (!contact) this.querySelector('[data-wi-contact-initial]')?.remove();
      const label = this.state === 'preorder' ? this.dataset.preorderLabel : this.dataset.add;
      const scopes = [this.root];
      if (!this.root.closest('.bls__product-quickview')) {
        const sticky = this.root.closest('.shopify-section')?.querySelector('#bls__sticky-addcart');
        if (sticky) { scopes.push(sticky); sticky.dataset.wiPurchaseContact = String(contact); }
      }
      for (const scope of scopes) {
        for (const button of scope.querySelectorAll('form[data-type="add-to-cart-form"] button[type="submit"][name="add"]')) {
          button.hidden = contact;
          if (contact && !button.disabled) { button.disabled = true; button.dataset.wiDisabled = 'true'; }
          if (!contact && button.dataset.wiDisabled === 'true') { button.disabled = false; delete button.dataset.wiDisabled; }
          const span = button.querySelector('.hidden-loading') || button.querySelector('span');
          if (span && span.textContent.trim() !== label) span.textContent = label;
        }
        for (const payment of scope.querySelectorAll('.shopify-payment-button,.bls__product-dynamic-checkout,.product-form__quantity')) {
          payment.hidden = contact;
        }
      }
      const status = this.root.querySelector('.bls__availability-value');
      const text = contact ? (es ? 'Contáctanos' : 'Contact us') : this.state === 'supplier' ? (es ? 'Disponible por encargo' : 'Available to order') : this.state === 'preorder' ? this.dataset.preorderLabel : window.variantStrings?.inStock || (es ? 'En existencia' : 'In stock');
      if (status && status.textContent !== text) status.textContent = text;
    }
    async refresh() {
      if (this.refreshing || document.hidden) return;
      this.refreshing = true;
      try {
        const url = new URL(this.dataset.url, location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('_wi_refresh', String(Date.now()));
        const response = await fetch(url, {cache:'no-store', signal:AbortSignal.timeout(10000)});
        if (!response.ok) throw new Error('Availability refresh failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const element = html.querySelector('wi-purchase-rules script');
        if (element) this.records = new Map(JSON.parse(element.textContent).map(r => [String(r.id),r]));
      } catch {} finally { this.refreshing = false; this.apply(); }
    }
    disconnectedCallback() {
      clearInterval(this.timer); this.observer?.disconnect();
      this.root?.removeEventListener('change', this.change);
      this.scope?.removeEventListener('submit', this.guard, true);
      this.scope?.removeEventListener('click', this.guard, true);
      this.root = null;
    }
  });
})();
